// Styles
import { Wrapper } from "./styles";

type ColorProps = {
  color: string;
};

export default function Divisor({ color }: ColorProps) {
  return <Wrapper color={color} />;
}
